import { Button } from '@mui/material';
import { useAppDispatch } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { clearMapDrawFeatures } from '../../onboardingSlice';

const ClearMapDrawFeaturesButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <Button
      variant='contained'
      color='secondary'
      onClick={() => {
        dispatch(clearMapDrawFeatures());
      }}
      fullWidth
    >
      {t('Clear Drawing', { ns: 'common' })}
    </Button>
  );
};

export default ClearMapDrawFeaturesButton;
